import { PageContainer, PageHeader, Spread } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import { ExportCsvButton } from '@/components/ExportCsv/ExportCsvButton'
import { IntroductionDialog } from '@/components/IntroductionDialog'
import {
  activeAssortmentExportQueryOptions,
  activeAssortmentSearchSchema,
  useActiveAssortment,
} from '@/hooks/queries/useAssortment'
import { useTablePagination } from '@/hooks/useTablePagination'
import { queryClient } from '@/main'
import { INTRO_DIALOGS } from '@/stores/tutorials'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import ActiveAssortmentDataTable from './-components/ActiveAssortmentDataTable'

export const Route = createFileRoute('/_auth/_modules/_app/assortment/active/')({
  component: RouteComponent,
  validateSearch: (search) => activeAssortmentSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('assortment')

  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  const { pageSize, onPageSizeChange } = useTablePagination({ navigate, search })

  const { data, isPending, error } = useActiveAssortment({
    ...search,
    page: search.page ?? 1,
    pageSize,
  })

  const getCsvExport = () => queryClient.ensureQueryData(activeAssortmentExportQueryOptions(search))

  return (
    <>
      <IntroductionDialog
        dialogId={INTRO_DIALOGS.ACTIVE_ASSORTMENTS}
        title={t('tutorials.activeAssortment.dialog.title')}
        guideUrl="/products/active-assortment/"
      >
        {t('tutorials.activeAssortment.dialog.description')}
      </IntroductionDialog>

      <PageContainer className="pb-28">
        <Spread>
          <PageHeader>{t('activeAssortmentPage.header')}</PageHeader>
          <ExportCsvButton getCsvExport={getCsvExport} rowCount={+(data?.rowCount ?? 0)} />
        </Spread>

        <Card>
          <CardContent className="pt-6">
            <ActiveAssortmentDataTable
              data={data}
              isPending={isPending}
              error={error}
              pageSize={pageSize}
              onPageSizeChange={onPageSizeChange}
            />
          </CardContent>
        </Card>
      </PageContainer>
    </>
  )
}
